import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  deleteButton: {
    marginRight: theme.spacing(2),
    paddingRight: theme.spacing(1),
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
}));
